module.exports = __webpack_public_path__ + "img/g14.21105e9b.jpg";